import { SoftwareRovoStartPageTemplate } from "../../../../templates/software/rovo/start/software-rovo-start-page/src/software-rovo-start-page.template";

import { useCallback } from "react";

import { useAnalyticsEvents } from "@atlaskit/analytics-next";

import ErrorBoundary from "@/components/error-boundary";
import { ErrorScreen } from "../../../../templates/software/rovo/start/software-rovo-start-page/src/components/error-screen";

export const SoftwareRovoStartPage = () => {
    const { createAnalyticsEvent } = useAnalyticsEvents();

    const handleOnError = useCallback(
        (error: Error) => {
            createAnalyticsEvent({
                action: "failed",
                eventType: "track",
                actionSubject: "SoftwareRovoStartPage",
                source: "SoftwareRovoStartPage",
                attributes: {
                    error: error.message
                }
            }).fire();
        },
        [createAnalyticsEvent]
    );

    return (
        <ErrorBoundary fallback={<ErrorScreen />} onError={handleOnError}>
            <SoftwareRovoStartPageTemplate />
        </ErrorBoundary>
    );
};
